import { getkwargs } from "../../utilities/functions";
import { onChange } from "../onchange";

export const onChangeCompany = ({ context, company_id }) => {
  // console.log(
  //   "context and company id in on change company",
  //   context,
  //   company_id
  // );
  const model = "res.company";
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [
        [],
        {},
        [],
        {
          active_social_media_lines: "",
          "active_social_media_lines.ayrshare_id": "",
          "active_social_media_lines.company_id": "",
          "active_social_media_lines.display_name": "",
          "active_social_media_lines.selected": "",
          bank_ids: "",
          "bank_ids.acc_holder_name": "",
          "bank_ids.acc_number": "",
          "bank_ids.bank_id": "",
          "bank_ids.branch_name": "",
          "bank_ids.cr_img": "",
          "bank_ids.sequence": "",
          city: "",
          company_registry: "",
          connected: "",
          country_code: "",
          country_id: "1",
          currency_id: "",
          email: "",
          enable_contact_map_support: "",
          facebook_analytics: "",
          favicon: "",
          instagram_analytics: "",
          logo: "",
          name: "",
          parent_id: "",
          partner_gid: "",
          partner_id: "1",
          phone: "",
          sales_notify_template_id: "",
          sequence: "",
          social_facebook: "",
          social_github: "",
          social_instagram: "",
          social_linkedin: "",
          social_twitter: "",
          social_youtube: "",
          state_id: "1",
          street: "",
          street2: "",
          subscription_id: "",
          "subscription_id.company_id": "",
          "subscription_id.config_enable_1_omr_promotion_months": "",
          "subscription_id.config_enable_1_omr_promotion_offer": "",
          "subscription_id.date_end": "",
          "subscription_id.date_payment_started": "",
          "subscription_id.date_start": "1",
          "subscription_id.sale_order_id": "",
          "subscription_id.should_be_renewed": "",
          "subscription_id.show_discount_button": "",
          "subscription_id.state": "",
          "subscription_id.subscription_template_id": "1",
          twitter_analytics: "",
          vat: "",
          website: "",
          zip: "",
          __last_update: "",
        },
      ],
      model,
      method: "onchange",
      ...getkwargs({ company_id, context, model, view_type: "form" }),
    },
  });

  return onChange(raw, model);
};
